import { ChangeEvent, Fragment, useEffect, useState } from "react";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import {
  Button,
  CircularProgress,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  // Collapse,
  // Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useMutation } from "react-query";
import { getPriorApprovalsPatients } from "../../services";
import { FormOnChangeEventType } from "../../../EMR/types";
import {
  PriorApprovalPateintSearchParams,
  PriorApprovalPatientType,
} from "../types";
import moment from "moment";
import debounce from "../../../utilis/methods/networkHandling";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReplayCircleFilledIcon from "@mui/icons-material/ReplayCircleFilled";
import { submitPriorApproval } from "../../../EMR/services";
import usePopup from "../../../hooks/usePopup";
import { PriorApprovalSubmitParamsType } from "../../../EMR/components/layouts/types";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "../../../routes/moduleRouteList";
import insuranceRouteList from "../../routeList";
import { clinicId } from "../../../constants";
import { setItem, storageKey } from "../../../utilis/methods/storage/storage";
import useAuthentication from "@hooks/useAuthentication";
const baseRoute = (window as any)._env_?.BASE_URL;

function PriorRequestList() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { showSnackbar, CustomModal } = usePopup();
    const{user}= useAuthentication();
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [confirmAction, setConfirmAction] = useState<{
    item: any;
    index: number;
  } | null>(null);
  const [searchParams, setSearchParams] =
    useState<PriorApprovalPateintSearchParams>({
      searchDate: moment().format("YYYY-MM-DD"),
      searchText: "",
      pageNo: 0,
      pageSize: 25,
      refetch: true,
    });
  const [submissionResponse, setSubmissionResponse] = useState<any>(null);
  const { handleSubmit, control, setValue } = useForm();
  const [selected, setSelected] = useState(-1);

  const { mutate: savePriorApproval, isLoading: submitLoading } = useMutation(
    submitPriorApproval,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          const submitRsponse = result?.response[0] || null;
          if (Boolean(submitRsponse)) {
            if (submitRsponse?.Success) {
              showSnackbar({
                message: submitRsponse?.UserMessage,
                open: true,
                variant: "success",
                duration: 2000,
              });
              setSearchParams((prev) => ({
                ...prev,
                refetch: true,
              }));
            } else {
              setSubmissionResponse(submitRsponse);
              setOpen(Boolean(submitRsponse));
            }
          }else{
            showSnackbar({
              message: "Submission error !",
              open: true,
              variant: "warning",
              duration: 2000,
            });
          }
      
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    }
  );

  const {
    mutate: fetchPatients,
    data: patientList,
    isLoading: patientListLoading,
  } = useMutation(getPriorApprovalsPatients, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setSearchParams((prev) => ({
          ...prev,
          refetch: false,
        }));
      }
    },
  });

  const priorList: any[] = [
    {
      memberID: 10,
      EmiratesID: 10,
      uniqAuthID: 1,
      PatientID: 10,
    },
  ];

  const onSubmit = (value: any) => {
    console.log(value);
  };

  const handleChangePage = (_: unknown, pageNo: number) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNo,
      refetch: true,
    }));
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    const pageSize = parseInt(event.target.value, 10);
    setSearchParams((prev) => ({
      ...prev,
      pageSize,
      refetch: true,
    }));
  };

  const handleChange = (e: FormOnChangeEventType) => {
    const { target } = e;
    setSearchParams((prve) => ({
      ...prve,
      refetch: true,
      [target.name]: target.value,
    }));
  };

  const onChange = debounce(handleChange, 500);

  // const handleRowClick = (e: any) => {
  //   const index = parseInt(e.currentTarget.getAttribute("data-index") || "-1");
  //   console.log(index);
  //   setSelected(index)
  // };

  const handleSubmitPriorApprovals = (
    data: PriorApprovalPatientType,
    index: number
  ) => {
    const saveParam: PriorApprovalSubmitParamsType = {
      priorAuthId: null,
      approvalCode: "N/A",
      authType: "authType",
      cancelDate: null,
      clinicId: clinicId,
      clinician: data.clinicianName,
      clinicianCode: data.clinicianCode,
      comments: "N/A",
      createdId: data.createdById,
      emiratesId: data.emiratesId,
      encFacilityId: data.encFacilityId,
      encType: "OP",
      endDate: null,
      idenfyWproce: 0,
      ip: "192.168.1.1",
      memberId: data.cardNo,
      modifiedId:Number(user?.userId),
      modifiedDate: null,
      payerId: data.payerId,
      providerId: data.encFacilityId,
      result: "result",
      startDate: moment().toISOString(),
      status: 1,
      transDate: moment().toISOString(),
      uniqAuthId: null,
      visitNo: data.encounterId,
      encounterId: data.encounterId,
      dispositionFlag: 1,
      postOfficeId: data.postOfficeId,
    };
    savePriorApproval([saveParam]);
    setSelected(index);
  };

  const handleEditActivity = (e: any) => {
    const encounterId =
      e.currentTarget.getAttribute("data-encounterid") || "-1";
    const patientMasterId = e.currentTarget.getAttribute("data-patientid");
    const emrNo = e.currentTarget.getAttribute("data-emrno");
    setItem(storageKey.priorDetailsKey, { encounterId, patientMasterId });
    navigate(
      `${baseRoute}${moduleRoutes.mainRoute}/${moduleRoutes.insurance}/${insuranceRouteList.priorApprovalPatientEdit}/${encounterId}/${patientMasterId}?page=priorapproval&emrno=${emrNo}`,
      { state: { encounterId, patientMasterId } }
    );
  };

  useEffect(() => {
    console.log(searchParams.searchDate,searchParams.refetch);
    
    if (searchParams.searchDate && searchParams.refetch) {
      fetchPatients(searchParams);
      setValue("searchDate", searchParams.searchDate);
    }
  }, [searchParams]);
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates ID";
const idHeading = "Civil ID"
const headings = [
  "SL NO",
  "Name",
  "Patient Id",
  idHeading,
  "Payer",
  "Receiver",
  "Options",
];

  return (
    <div>
      <CustomModal
        title={submissionResponse?.Success ? "Success" : "Error"}
        open={open}
        setOpen={setOpen}
      >
        <div className="flex flex-col gap-2 overflow-y-auto p-4">
          <Typography
            fontSize={"1rem"}
            color={submissionResponse?.Success ? "success" : "error"}
            fontWeight={600}
            sx={{
              maxWidth: "50vw",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            {submissionResponse?.UserMessage}
          </Typography>
          <div className="min-h-[55dvh] max-h-[55dvh]">
            {submissionResponse?.Error?.map((e: any, index: number) => (
              <div key={`errorList${index}`} className="flex gap-2">
                <span>{index + 1}. </span>
                <Typography
                  sx={{
                    maxWidth: "50vw",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {e.ErrorText}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </CustomModal>
      <CustomModal
        title="Confirmation"
        open={openConfirm}
        setOpen={setOpenConfirm}
      >
        <div className="p-4 flex flex-col gap-4">
          <Typography fontSize={".8rem"}>
            Are you sure you want to{" "}
            <strong>
              {confirmAction?.item?.isApproved ? "resubmit" : "submit"}
            </strong>{" "}
            this prior approval for{" "}
            <strong>{confirmAction?.item?.fullName}</strong>?
          </Typography>
          <div className="flex justify-end gap-3 mt-2">
            <Button
              onClick={() => setOpenConfirm(false)}
              variant="outlined"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={confirmAction?.item?.isApproved ? "primary" : "success"}
              onClick={() => {
                if (confirmAction) {
                  handleSubmitPriorApprovals(
                    confirmAction.item,
                    confirmAction.index
                  );
                }
                setOpenConfirm(false);
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </CustomModal>
      <TableContainer className="flex flex-col">
        <div className="flex justify-between p-2 border-b-2 items-center">
          {/* <Typography sx={{ fontWeight: "bold" }}>
            Prior Approval search
          </Typography> */}
          {/* <FilterComponent /> */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex gap-3">
            <CustomFormField
              control={control}
              element="datepicker"
              fieldProps={{ label: "Search date" }}
              name="searchDate"
              rules={{ required: false, onChange }}
            />
            <CustomFormField
              control={control}
              element="input"
              fieldProps={{ label: "Search" }}
              name="searchText"
              rules={{ required: false, onChange }}
            />
          </form>
        </div>

        <div className="h-[65dvh] max-h-[62dvh] overflow-y-auto">
          <Table
            size="small"
            className={priorList?.length ? "w-full" : "h-full"}
          >
            <TableHead
              className="sticky top-0"
              sx={{
                backgroundColor: theme.palette.background.paper,
                opacity: 1,
                zIndex: 10,
              }}
            >
              <TableRow>
                {headings.map((heading, index) => (
                  <TableCell key={`headingrow${index}`}>
                    <Typography
                      sx={{
                        color: theme.palette.text.primary,
                        fontWeight: "bold",
                      }}
                    >
                      {heading}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <CustomTableBody
              alert="No records"
              isData={Boolean(patientList?.response?.items?.length)}
              dataLoading={patientListLoading}
              totalSpan={{ row: 5, col: headings.length }}
            >
              {patientList?.response?.items?.map((item, index) => (
                <Fragment key={`tableList${index}`}>
                  <TableRow
                    key={`clickablerow${index}`}
                    // className="cursor-pointer"
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      backgroundColor:
                        index % 2 == 0 ? theme.palette.grey[100] : "",
                    }}
                  >
                      <TableCell>
        {searchParams.pageNo * searchParams.pageSize + index + 1}
      </TableCell>
                    <TableCell
                    // data-index={`${index}`}
                    // onClick={handleRowClick}
                    >
                      {item?.fullName}
                    </TableCell>
                    <TableCell
                    // data-index={`${index}`}
                    // onClick={handleRowClick}
                    >
                      {item?.patientId}
                    </TableCell>
                    <TableCell
                    // data-index={`${index}`}
                    // onClick={handleRowClick}
                    >
                      {item?.emiratesId}
                    </TableCell>
                    <TableCell
                    // data-index={`${index}`}
                    // onClick={handleRowClick}
                    >
                      {item?.payer}
                    </TableCell>
                    <TableCell
                    // data-index={`${index}`}
                    // onClick={handleRowClick}
                    >
                      {item?.receiver}
                    </TableCell>
                    <TableCell width={180}>
                      <div className="flex gap-2 items-center">
                        <Tooltip title="Add activiy">
                          <IconButton
                            onClick={handleEditActivity}
                            data-patientid={item?.patientMasterId}
                            data-encounterid={item?.encounterId}
                            data-emrno={item?.patientId}
                            color="primary"
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {item?.isApproved ? (
                          <Button
                            disabled={submitLoading}
                            onClick={() => {
                              setConfirmAction({ item, index });
                              setOpenConfirm(true);
                            }}
                            color={"primary"}
                            endIcon={
                              submitLoading && selected == index ? (
                                <CircularProgress size={18} color="primary" />
                              ) : (
                                <ReplayCircleFilledIcon />
                              )
                            }
                          >
                            resubmit
                          </Button>
                        ) : (
                          <Button
                            disabled={submitLoading}
                            onClick={() => {
                              setConfirmAction({ item, index });
                              setOpenConfirm(true);
                            }}
                            color={"success"}
                            endIcon={
                              submitLoading && selected == index ? (
                                <CircularProgress size={18} color="success" />
                              ) : (
                                <CheckCircleIcon />
                              )
                            }
                          >
                            <>submit &nbsp;&nbsp;&nbsp;</>
                          </Button>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        backgroundColor:
                          index % 2 == 0 ? theme.palette.grey[100] : "",
                      }}
                      colSpan={headings.length + 1}
                    >
                      <Collapse
                        in={selected == index}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ margin: 1 }}>
                          <div className="flex gap-2 items-center justify-end">

                          </div>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow> */}
                </Fragment>
              ))}
            </CustomTableBody>
          </Table>
        </div>
        <div className="border-t">
          <TablePagination
            sx={{ bgcolor: theme.palette.background.paper }}
            rowsPerPageOptions={[3, 5, 10]}
            component="div"
            count={patientList?.response?.totalCount || 0}
            rowsPerPage={searchParams.pageSize}
            page={searchParams.pageNo}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </TableContainer>
    </div>
  );
}

export default PriorRequestList;

// const createSampleData = () => {
//   let sampleData: any[] = [];
//   for (let i = 0; i < 20; i++) {
//     sampleData = [
//       ...sampleData,
//       {
//         memberID: `test${i}`,
//         EmiratesID: `test${i}`,
//         uniqAuthID: `test${i}`,
//         PatientID: `test${i}`,
//         tableData: `test${i}`,
//         sampleData: `test${i}`,
//       },
//     ];
//   }
//   return sampleData;
// };
